import classNames from "classnames";

// Components
import Button from "../../atoms/Button";

// Hooks
import useTranslate from "../../../hooks/useTranslate";

import "./styles.sass";

type InviteFriendLinkProps = {
  link: string;
  onClick: () => void;
};

const InviteFriendLink = (props: InviteFriendLinkProps) => {
  const { link, onClick: handleClick } = props;
  const t = useTranslate();
  const projectName = import.meta.env.VITE_APP_PROJECT_NAME;

  function truncateText(text, maxLength = 34) {
    if (text.length <= maxLength) {
      return text;
    }
    return `${text.substring(0, maxLength - 3)}...`;
  }

  const truncatedText = truncateText(link);

  const BlockClass = classNames("InviteFriendLink-block-ref", {
    "InviteFriendLink-block-ref_banger": projectName === "banger",
  });

  return (
    <div className="InviteFriendLink">
      <div className="InviteFriendLink-block">
        <span className="InviteFriendLink-block__title">
          {t("referral.link.title")}
        </span>
        <span className="InviteFriendLink-block__desc">
          {t("referral.link.copy")}
        </span>
        <div className={BlockClass}>
          <span className="InviteFriendLink-block-ref__link">
            {truncatedText}
          </span>
          <Button
            htmlType="button"
            label={t("referral.link.button")}
            variation="primary"
            className="InviteFriendLink-block-ref__btn"
            onClick={handleClick}
          />
        </div>
      </div>
    </div>
  );
};

export default InviteFriendLink;
